import { createFileRoute } from '@tanstack/react-router';
import { ApprovalRequestPage } from '../../../features/approval-requests/approval-request-page.tsx';

/** 17e: one approval request revision of a process gate (`GET /approval-requests/{requestId}`). */
export const Route = createFileRoute('/_app/approval-requests/$requestId')({
  component: ApprovalRequestRoute,
});

function ApprovalRequestRoute() {
  const { requestId } = Route.useParams();
  return <ApprovalRequestPage key={requestId} requestId={requestId} />;
}
